import { fromJS } from 'immutable';
import { valIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import { fetchPageContent } from '@client/connectivity/api.cms';
import {
  loadFundraisers,
  loadFundraiserTypes,
} from '@client/redux/fundraiser/fundraiserActions';

export const DUCK_HOME_PAGE_KEY = 'duckHomePageReducer';

const SET_HOME_PAGE_ERROR = 'SET_HOME_PAGE_ERROR';
const LOAD_HOME_PAGE_CMS = 'LOAD_HOME_PAGE_CMS';

/* REDUCER */
let defaultState = fromJS({
  pageData: {},
});

export default function (state = defaultState, action = {}) {
  switch (action.type) {
    case LOAD_HOME_PAGE_CMS: {
      return state.merge({
        pageData: fromJS(action.payload),
        errorMessage: '',
      });
    }
    case SET_HOME_PAGE_ERROR: {
      return state.merge({
        errorMessage: action.payload,
      });
    }
    default:
      return state;
  }
}

/* ACTIONS */
export function loadHomePageCms() {
  return function (dispatch) {
    return fetchPageContent('homePage').then((response) => {
      return dispatch({
        type: LOAD_HOME_PAGE_CMS,
        payload: response,
      });
    });
  };
}

export function loadHomePageData(searchParams) {
  return function (dispatch) {
    const homePageDataPromises = [
      dispatch(loadHomePageCms()),
      dispatch(loadFundraisers(searchParams)),
      dispatch(loadFundraiserTypes()),
    ];

    return Promise.all(homePageDataPromises);
  };
}

/* SELECTORS */
export const selectHomePageData = (state) => {
  return valIn(state[DUCK_HOME_PAGE_KEY], 'pageData');
};
